import * as fromDatatype from "../../../../models/datatype-library";

export class CurrentLocationStockBalanceMaxMinQtyDtoModel {
  inv_item_guid?: string;
  location_guid?: string;
  min_qty?: fromDatatype.IntegerDatatypeInterface;
  max_qty?: fromDatatype.IntegerDatatypeInterface;
}
